import {useQuery} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config.ts";
import {ListResponseDto} from "@/@types/base.types.ts";
import {TenantDto} from "@/@types/auth.types.ts";
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";
import { useAuthUser } from '@/features/identity/hooks/useAuthUser';

export const useTenantsApi = () => {
    const axiosInstance = useAxiosAuth();
    const { user } = useAuthUser();

    const {data: tenants, isLoading: isTenantsLoading} = useQuery({
        queryKey: [ApiConfig.queries.auth.queryKeys.tenants, user?.userName],
        queryFn: async () => {
            const response = await axiosInstance.get<ListResponseDto<TenantDto>>(ApiConfig.queries.auth.endpoints.tenants);
            return response.data;
        },
        enabled: !!user
    })

    return {
        tenants,
        isTenantsLoading,
    }
}